import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton as _ModalCloseButton } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
const ModalCloseButton = _ModalCloseButton;

/**
 * [Chakra Modal docs](https://chakra-ui.com/docs/components/modal/usage)
 */
export const CUIModal = Modal;
export const CUIModalOverlay = ModalOverlay;
export const CUIModalContent = ModalContent;
export const CUIModalHeader = ModalHeader;
export const CUIModalFooter = ModalFooter;
export const CUIModalBody = ModalBody;
export const CUIModalCloseButton = args => {
  return /*#__PURE__*/_jsx(ModalCloseButton, Object.assign({
    size: "lg"
  }, args));
};